import { render, staticRenderFns } from "./miniprogramCard.vue?vue&type=template&id=2103973a&scoped=true"
import script from "./miniprogramCard.vue?vue&type=script&lang=js"
export * from "./miniprogramCard.vue?vue&type=script&lang=js"
import style0 from "./miniprogramCard.vue?vue&type=style&index=0&id=2103973a&prod&scoped=true&lang=css"
import style1 from "./miniprogramCard.vue?vue&type=style&index=1&id=2103973a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103973a",
  null
  
)

export default component.exports